export enum JobsViewType {
  Calendar = 'calendar',
  Table = 'table',
}

export enum CalendarViewType {
  Weekly = 'weekly',
  Monthly = 'monthly',
}